import React from 'react';
import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import IntealthLogo from '../../../../assets/intealth-logo-with-motto.png';

export const PdfHeader: React.FC = () => {
  const styles = StyleSheet.create({
    image: {
      width: '30%'
    },
    leftColumn: {
      flexDirection: 'row',
      marginLeft: 19,
      marginRight: 19,
      marginTop: 25,
      paddingBottom: 10,
      justifyContent: 'space-between',
      borderBottom: '2.5px solid #BCCBCE'
    },
    titleText: {
      width: 280,
      color: 'gray',
      fontFamily: 'Libre Franklin Bold',
      textAlign: 'right',
      lineHeight: 1.3
    }
  });

  return (
    <View style={styles.leftColumn}>
      <Image style={styles.image} src={IntealthLogo} />
      <Text style={styles.titleText}>ECFMG® Credential Verification for Health Professionals</Text>
    </View>
  );
};
export default PdfHeader;
